import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 인스턴스를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getInstanceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-apm/get-instance-list.do`, params);
  },
  /**
   * 최근 3일 이내 등록된 장비 개수를 조회한다.
   * @return {[type]} [description]
   * @author jda
   */
  getRecentRegisteredInstanceCount() {
    return axios.get(`${baseUrl}/settings/device-registration-apm/get-recent-registered-instance-count.do`);
  },
  /**
   * 인스턴스 정보를 변경한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  updateInstanceInfo(params) {
    return axios.post(`${baseUrl}/settings/device-registration-apm/update-instance-info.do`, params);
  },
  deleteInstances(params) {
    return axios.post(`${baseUrl}/settings/device-registration-apm/delete-instances.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-apm.js